import { Component } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../../service/global.service';
import { CommonModule } from '@angular/common';
import { CustomerDashboardMenuComponent } from '../customer-dashboard-menu/customer-dashboard-menu.component';
import { NgxStarsModule } from 'ngx-stars';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { decrypt, encrypt } from '../service/utils';
import { ProductChatWindowComponent } from '../chat-form/product-chat-window/product-chat-window.component';
import { UserListComponent } from '../chat-form/user-list/user-list.component';
import { ViewProductFormDetailsComponent } from '../products/view-product-form-details/view-product-form-details.component';

@Component({
  selector: 'app-customer-product-order-history',
  standalone: true,
  imports: [CommonModule,
    CustomerDashboardMenuComponent,
    InfiniteScrollModule,
    NgxStarsModule,
    ReactiveFormsModule,
  FormsModule,UserListComponent,ProductChatWindowComponent,ViewProductFormDetailsComponent],
  templateUrl: './customer-product-order-history.component.html',
  styleUrl: './customer-product-order-history.component.scss'
})
export class CustomerProductOrderHistoryComponent {
  pageSize = 200;
  currentPage: any;
  itemsPerPage: any;

  productOrderData: Array<any>=[];
  orderId: any;
  productOrderList: any = [];
  pageNo: any = 0;

  selectedUser:any=null;

  viewDetailsOffcanvas:boolean=false;

  constructor(private _homeService: HttpService, private router: Router,public gS: GlobalService,private route: ActivatedRoute
  ) {
    if (this.gS.customerId != null) {

    } else {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const encryptedOrderId = params['orderId'];
      // const realOrderId = decrypt(encryptedOrderId);
      // if (realOrderId) {
        // this.orderId = realOrderId;
        this.orderId = encryptedOrderId;
      // }
    });
  }

  viewPalmOrder(item: any) {
    this.orderId = item?.id
  }

  eventClosePalmOrder(event: any) {
    this.orderId = null;
  }

  onScroll() {
    console.log('infilite scroll');
    this.pageNo = this.pageNo + 1;
    // this.getProductOrder();
  }

  chatNow(item:any){
    const encryptedOrderId = encrypt(item?.orderId?.toString());

    if (encryptedOrderId) {
      this.gS.navigateWithExtras('/chat-window', {
        queryParams: {
          orderId: encryptedOrderId,
        }
      })
    }
  }

  selectUser(event:any){
    this.viewDetailsOffcanvas=false;
    this.selectedUser=event;
    this.gS.triggerCommonListner({
      type:'selectUser',
      data:this.selectedUser
    })
  }

  openViewDetails(event:any){
    console.log(event,'event');
    if(event){
      this.viewDetailsOffcanvas=true;
    }
  }

  closeOffcanvas(event:any){
    if(event){
      this.viewDetailsOffcanvas=false;
    }
  }
}
